export default __webpack_public_path__ + "static/media/credit_card_blue.fcb97b71.svg";